import React from 'react'
import { useSelector } from 'react-redux'

import Widget from '@/components/widget/Widget'

import { ExportsTable } from './ExportsTable'

const formatMb = (bytes) => `${(bytes / (1024 * 1024)).toFixed(1)} MB`

export const TableSection = () => {
  const { loading, data } = useSelector((state) => state.scorecards)

  // The table only ever shows 20 rows, so while the full export streams in the
  // background there is nothing on screen to indicate anything is happening --
  // and a large export runs for minutes. Say so, and show it growing, rather
  // than leaving a bare spinner.
  const isStreaming = loading.advancedExportsStreamedCsv
  const hasFailed = data.advancedExportsCsvFailed
  const bytes = data.advancedExportsCsvBytes

  const composeSubtitle = () => {
    if (isStreaming) {
      return `(Shows up to 20 results) · Preparing your full export${
        bytes ? ` — ${formatMb(bytes)} so far` : ''
      }. Large exports can take several minutes; leave this page open.`
    }

    // Say the export failed rather than leaving a download button that
    // silently does nothing -- or worse, quietly hands back the 20 preview
    // rows, which is what made backend failures look like a 20-row cap.
    if (hasFailed) {
      return '(Shows up to 20 results) · Your full export failed. Run Preview again to retry.'
    }

    return '(Shows up to 20 results)'
  }

  return (
    <Widget
      label="Preview Data"
      subtitle={composeSubtitle()}
      showCsvDownload={!loading.scores && !isStreaming && !hasFailed}
    >
      <ExportsTable />
    </Widget>
  )
}
